import api from './api';

const RoleService = {
  // Get roles by store ID
  getRolesByStore: async () => {
    try {
      const response = await api.get('/roles');
      return response.data;
    } catch (error) {
      console.error('Failed to load roles:', error);
      throw error;
    }
  },

  // Create new role
  createRole: async (roleData) => {
    const response = await api.post('/roles', roleData);
    return response.data;
  },

  // Update role
  updateRole: async (roleId, roleData) => {
    const response = await api.patch(`/roles/${roleId}`, roleData);
    return response.data;
  },

  // Delete role
  deleteRole: async (roleId) => {
    const response = await api.delete(`/roles/${roleId}`);
    return response.data;
  }
};

export default RoleService;

